var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-carousel",
        {
          staticStyle: { "border-radius": "0px" },
          attrs: {
            arrow: "never",
            height: "85px",
            "indicator-position": "none",
          },
          on: {
            change: function ($event) {
              return _vm.changePic($event)
            },
          },
        },
        _vm._l(_vm.bannerList, function (item, index) {
          return _c(
            "el-carousel-item",
            { key: index },
            [
              _c("el-image", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  src: item.bannerPic
                    ? item.bannerPic
                    : require("@/assets/customPage/" +
                        _vm.$props.itemDetail.componentCode +
                        "_ba.png"),
                  fit: "cover",
                },
              }),
            ],
            1
          )
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "my-box", style: { background: _vm.bgStyle } },
        _vm._l(_vm.dataList, function (item, index) {
          return _c(
            "div",
            { key: index, staticStyle: { width: "49%", "margin-top": "6px" } },
            [
              _c("el-image", {
                key: index,
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  display: "block",
                },
                attrs: {
                  src: item.bannerPic
                    ? item.bannerPic
                    : require("@/assets/customPage/" +
                        _vm.$props.itemDetail.componentCode +
                        "_" +
                        ((index + 1) % 2 === 0 ? "left" : "right") +
                        ".png"),
                  fit: "cover",
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }